export default __webpack_public_path__ + "static/media/MaduroChurchill.ae906505.png";